<ng-container *ngIf="!loggedData">
	<form [formGroup]="routeForm">
		<mat-card class="mat-elevation-z">
			<div class="flex flex-row justify-between">
				<div class="flex flex-row">
					<mat-icon class="icon-lg mr-12" svgIcon="sync_alt"></mat-icon>
					<mat-card-content class="fs-24 fw-700">{{edit ? ('INSTANCE_DETAILS.EDIT_ROUTE' | transloco) : ('INSTANCE_DETAILS.ADD_ROUTE' | transloco)}}</mat-card-content>
				</div>
				<mat-icon class="justify-items-end cursor-pointer icon-lg" (click)="closeSidenav()"  svgIcon="close"></mat-icon>
			</div>
			<mat-divider></mat-divider>
			<mat-card-content>
				<div class="flex flex-col form-group mat-subtitle-2 mt-16">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12" for="username">{{'INSTANCE_DETAILS.ROUTE_NAME' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.ROUTE_NAME' | transloco"
						matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<input type="text" placeholder="{{'ROUTE_FORM.ENTER_ROUTE_NAME' | transloco}}"
						formControlName="routeName" class="fw-500" required >
						<app-error [control]="routeForm.get('routeName')"></app-error>
				</div>
			</mat-card-content>
			<mat-card-content>
				<div class="flex flex-row items-center">
				<div class="flex flex-col form-group mat-subtitle-2 mt-16">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12">{{'ROUTE_FORM.DESTINATION_TYPE' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ROUTE_FORM.DESTINATION_TYPE' | transloco"
						matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<mat-button-toggle-group class="flex flex-row toggle-button items-center" #destinationType="matButtonToggleGroup" formControlName="destinationType">
						@if (isArtifactoryFeature) {
						<mat-button-toggle value="artifactory">
							{{'ROUTE_FORM.ARTIFACTORY' | transloco | titlecase}}
						</mat-button-toggle>
					    }
						<mat-button-toggle value="fileshare">
							{{'ROUTE_FORM.FILESHARE' | transloco | titlecase}}
						</mat-button-toggle>
					</mat-button-toggle-group>
				</div>
				<div class="flex flex-col form-group mat-subtitle-2 mt-16 ml-32">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12">{{'INSTANCE_DETAILS.DIRECTION' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.DIRECTION' | transloco"
						matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<mat-button-toggle-group class="flex flex-row toggle-button items-center" #direction="matButtonToggleGroup" formControlName="direction">
						<mat-button-toggle value="inbound">
							{{'ROUTE_FORM.INBOUND' | transloco | titlecase}}
						</mat-button-toggle>
						<mat-button-toggle value="outbound">
							{{'ROUTE_FORM.OUTBOUND' | transloco | titlecase}}
						</mat-button-toggle>
					</mat-button-toggle-group>
				</div>
				</div>
			</mat-card-content>
			<!-- <mat-card-content>
				<div class="flex flex-col form-group mat-subtitle-2 mt-16">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12" for="username">{{'INSTANCE_DETAILS.HOME_PATH' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.HOME_PATH' | transloco"
							matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<input type="text" placeholder="{{'ROUTE_FORM.ENTER_HOME_PATH' | transloco}}"
						formControlName="sourcePath" class="fw-500" required >
						<app-error [control]="routeForm.get('sourcePath')"></app-error>
				</div>
			</mat-card-content> -->
		@if (this.routeForm.get('destinationType')?.value === 'fileshare') {
			<mat-card-content>
				<div class="flex flex-col form-group mat-subtitle-2 mt-16">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12" for="username">{{'INSTANCE_DETAILS.COMPONENT_STORAGE' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'/subscriptions/******/resourceGroups/******/providers/Microsoft.Storage/storageAccounts/accountname'"
							matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<input type="text" placeholder="{{'ROUTE_FORM.ENTER_COMPONENT_STORAGE' | transloco}}"
						formControlName="componentStorage" class="fw-500" required >
						<app-error [control]="routeForm.get('componentStorage')"></app-error>
						<!-- <div class="flex flex-row">
							<a class="text-decoration p-0" href="{{dataLink}}" target="_blank" title="">
								<mat-icon svgIcon="link" class="icon-sm ml-4"></mat-icon></a>
							<span class="max-limit-per-line">{{'INSTANCE_DETAILS.COMPONENT_STORAGE_EXAMPLE' | transloco}}</span>
						</div> -->
				</div>
			</mat-card-content>
			<mat-card-content>
				<div class="flex flex-col form-group mat-subtitle-2 mt-16">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12" for="username">{{'INSTANCE_DETAILS.COMPONENT_FILE_SHARE' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.COMPONENT_FILE_SHARE' | transloco"
							matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<input type="text" placeholder="{{'ROUTE_FORM.ENTER_COMPONENT_FILE_SHARE' | transloco}}"
						formControlName="componentFileShare" class="fw-500" required >
						<app-error [control]="routeForm.get('componentFileShare')"></app-error>
				</div>
			</mat-card-content>
			<mat-card-content>
				<div class="flex flex-col form-group mat-subtitle-2 mt-16">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12" for="username">{{'INSTANCE_DETAILS.COMPONENT_FILE_PATH' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.COMPONENT_FILE_PATH' | transloco"
							matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<input type="text" placeholder="{{'ROUTE_FORM.ENTER_COMPONENT_FILE_PATH' | transloco}}"
						formControlName="componentFilePath" class="fw-500" required >
						<app-error [control]="routeForm.get('componentFilePath')"></app-error>
				</div>
			</mat-card-content>
			<mat-card-content>
				<div class="flex flex-col form-group mat-subtitle-2 mt-16">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12">{{'INSTANCE_DETAILS.ENCRYPTION' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.ENCRYPTION' | transloco"
							matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<span class="mt-10">
						<mat-slide-toggle formControlName="encEnabled" [checked]="encEnabledData" (change)="encEnabled($event)">
							<span class="toggle-label">{{(encEnabledData === true ? 'ADD_VERSION.TRUE' : 'ADD_VERSION.FALSE') | transloco}}</span>
						</mat-slide-toggle>
					</span>
				</div>
			</mat-card-content>
			<mat-card-content *ngIf="encryptionKeyEnable">
				<div class="flex flex-col form-group mat-subtitle-2 mb-16 mt-10">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12" for="username">{{'INSTANCE_DETAILS.ENCRYPTION_KEY' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.ENCRYPTION_KEY_INFO' | transloco"
							matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<ng-container *ngIf="!sftpEncKeyRotation">
						<div class="flex flex-row input-border items-center">
							<input [type]="hide ? 'password' : 'text'" placeholder="{{'ROUTE_FORM.ENCRYPTION_KEY' | transloco}}"
								formControlName="encKey" class="fw-500 border-none" id="password" required>
							<mat-icon class="icon-lg mr-12" [svgIcon]="hide ? 'visibility_off' : 'visibility'" (click)="hideShowFunction()"></mat-icon>
						</div>
						<app-error [control]="routeForm.get('encKey')"></app-error>
					</ng-container>
					<ng-container *ngIf="sftpEncKeyRotation">
						<mat-select class="fw-500 form-select fs-16 add-route" placeholder="{{ 'ROUTE_FORM.ENCRYPTION_KEY' | transloco }}"
							[(value)]="selectedKey" (selectionChange)="selectionChanged($event.value)" 
							formControlName="encKeyName" (openedChange)="onDropdownOpen()"> 
							<mat-select-trigger>{{ selectedKey?.name }}
								<span *ngIf="selectedKey?.expirationDate" class="expiry-badge">Expires on: {{ selectedKey.expirationDate }}</span>
							</mat-select-trigger>
							<!-- Search Bar -->					
							<div class="pt-2 pb-0">
								<div class="search-wrapper">
								<mat-icon class="search-icon" svgIcon="search"></mat-icon>
								<input
									[(ngModel)]="searchKeyValue"
									[ngModelOptions]="{ standalone: true }"
									(ngModelChange)="searchKeyChanged($event)"
									type="text"
									class="fw-500 search-input"
									placeholder="{{ 'INSTANCE_DETAILS.ENCRYPTION_SEARCH_KEY' | transloco }}"
								/>
								</div>
							</div>
							<!-- No Keys Found Message -->
							<mat-option *ngIf="filteredEncryptionKeys.length === 0" disabled>
								{{ 'INSTANCE_DETAILS.NO_ENCRYPTION_DATA' | transloco }}
							</mat-option>
							<!-- List of Filtered Keys -->
							<mat-option *ngFor="let key of filteredEncryptionKeys" [value]="key">
								{{ key.name }}
							</mat-option>
						</mat-select>
						<div *ngIf="selectedKey?.publicKey" class="public-key-box">
							<div class="key-content">
								<span class="public-key-text">{{ selectedKey.publicKey }}</span>
								<mat-icon class="h-18 w-18 mr-6" [ngClass]="[copyEnd ? 'copiedEnd': 'copyEnd']"
									[svgIcon]="copyEnd ? 'check' : 'content_copy'" (click)="onCopyEndPoint(selectedKey?.publicKey)">
								</mat-icon>
							</div>
						</div>
						<app-error [control]="routeForm.get('encKey')"></app-error>
						<app-error [control]="routeForm.get('encKeyName')"></app-error>
					</ng-container>
				</div>
			</mat-card-content>
		} @else {
			<mat-card-content>
				<div class="flex flex-col form-group mat-subtitle-2 mt-16">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12" for="username">{{'INSTANCE_DETAILS.COMPONENT_FILE_PATH' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'INSTANCE_DETAILS.COMPONENT_FILE_PATH' | transloco"
							matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<input type="text" placeholder="{{'ROUTE_FORM.ENTER_COMPONENT_FILE_PATH' | transloco}}"
						formControlName="componentFilePath" class="fw-500" required >
						<app-error [control]="routeForm.get('componentFilePath')"></app-error>
				</div>
			</mat-card-content>
			<mat-card-content>
				<div class="flex flex-col form-group mat-subtitle-2 mt-16">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12" for="username">{{'ROUTE_FORM.CI_PROVIDER' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ROUTE_FORM.CI_PROVIDER' | transloco"
							matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<input type="text" placeholder="{{'ROUTE_FORM.ENTER_CIPROVIDER' | transloco}}"
						formControlName="ciProvider" class="fw-500" required >
						<app-error [control]="routeForm.get('ciProvider')"></app-error>
				</div>
			</mat-card-content>
			<mat-card-content>
				<div class="flex flex-col form-group mat-subtitle-2 mt-16">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12" for="username">{{'ROUTE_FORM.PROJECT_ID' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ROUTE_FORM.PROJECT_ID' | transloco"
							matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<input type="text" placeholder="{{'ROUTE_FORM.ENTER_PROJECTID' | transloco}}"
						formControlName="projectName" class="fw-500" required >
						<app-error [control]="routeForm.get('projectName')"></app-error>
				</div>
			</mat-card-content>
			<mat-card-content>
				<div class="flex flex-col form-group mat-subtitle-2 mt-16">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12" for="username">{{'ROUTE_FORM.BRANCH' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ROUTE_FORM.BRANCH' | transloco"
							matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<input type="text" placeholder="{{'ROUTE_FORM.ENTER_BRANCH' | transloco}}"
						formControlName="branch" class="fw-500" required >
						<app-error [control]="routeForm.get('branch')"></app-error>
				</div>
			</mat-card-content>
			<mat-card-content>
				<div class="flex flex-col form-group mat-subtitle-2 mt-16">
					<div class="flex flex-row items-center">
						<label class="fw-700 fs-12">{{'ROUTE_FORM.CI_TRIGGER_ENABLED' | transloco}}</label>
						<mat-icon svgIcon="info" class="icon-sm ml-4" matTooltipClass="form-tooltip right" [matTooltip]="'ROUTE_FORM.CI_TRIGGER_ENABLED' | transloco"
							matTooltipPosition="{{Constants.POSITION_RIGHT}}"></mat-icon>
					</div>
					<span class="mt-10">
						<mat-slide-toggle formControlName="ciTriggerEnabled">
							<span class="toggle-label">{{(routeForm.get('ciTriggerEnabled')?.value === true || routeForm.get('ciTriggerEnabled')?.value === 'true'  ? 'ADD_VERSION.TRUE' : 'ADD_VERSION.FALSE') | transloco }}</span>
						</mat-slide-toggle>
					</span>
				</div>
			</mat-card-content>
		}
		</mat-card>
		<span class="flex-auto"></span>
		<mat-divider class="mb-32 mt-20"></mat-divider>
		<div class="flex flex-row justify-end w-100-percent">
			<button type="cancel" class="white" (click)="closeSidenav()">{{'DIALOG.CANCEL' | transloco}}</button>
			<button type="submit" class="accent ml-12" [ngClass]="{ 'disabled-btn': editData && !isFormChanged }"  [disabled]="editData && !isFormChanged" (click)="onSubmit()">{{'TENANT_FORM.SUBMIT' | transloco}}</button>
		</div>
	</form>
</ng-container>

<ng-container *ngIf="loggedData">
	<div class="mat-elevation-z tenant-details-container">
		<div class="flex flex-row justify-between pb-10">
			<div class="flex flex-row">
				<mat-icon class="icon-lg mr-12" svgIcon="sync_alt"></mat-icon>
			  	<div class="mat-headline-5 mb-6 fw-700">{{'INSTANCE_DETAILS.ROUTE_DETAILS' | transloco}}</div>
				<div [ngClass]="loggedData?.status" class="ml-12 p-2 flex justify-center">{{loggedData?.status === 'adding' ? 'In-Progress' : loggedData?.status === 'added' ? 'Created' : loggedData?.status === 'removing' ? 'In-Progress' : loggedData?.status === 'removed' ? 'Removed' : 'Failed'}}</div>
		  	</div>
		  	<mat-icon svgIcon="close" class="close-icon" (click)="closeSidenav()"></mat-icon>
		</div>
		<mat-divider class="mb-20 neutral-2"></mat-divider>
		<div class="flex flex-row">
			<div class="metrics pt-8 pb-8">
				<div>{{'INSTANCE_DETAILS.ROUTE_NAME' | transloco}}</div>
				<div class="overview-values fw-700">{{loggedData?.routeId}}</div>
			</div>
			<div class="pt-8 pb-8">
				<div>{{'INSTANCE_DETAILS.DIRECTION' | transloco}}</div>
				<div class="overview-values fw-700">{{loggedData?.direction ? loggedData?.direction : '--'}}</div>
			</div>
			<div class="pt-8 pb-8">
				<div>{{'ROUTE_FORM.DESTINATION_TYPE' | transloco}}</div>
				<div class="overview-values fw-700">{{loggedData?.destinationType ? loggedData?.destinationType : '--'}}</div>
			</div>
		</div>
		<mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
		<div class="flex flex-row">
			<div class="metrics pt-8 pb-8">
				<div>{{'INSTANCE_DETAILS.HOME_PATH' | transloco}}</div>
				<div class="overview-values fw-700">{{loggedData?.homePath ? loggedData?.homePath : '--'}}</div>
			</div>
		</div>
		<mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
		<div class="flex flex-row">
			<div class="pt-8 pb-8">
				<div>{{'INSTANCE_DETAILS.COMPONENT_STORAGE' | transloco}}</div>
				<div class="overview-values fw-700">
					<a href="javascript:void(0);" [title]="loggedData?.componentStorage" (click)="openUrl(loggedData?.componentStorage)">{{loggedData?.componentStorage ? loggedData?.componentStorage : '--'}}</a>
				</div>
			</div>
		</div>
		<mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
		<div class="flex flex-row">
			<div class="metrics pt-8 pb-8">
				<div>{{'INSTANCE_DETAILS.COMPONENT_FILE_SHARE' | transloco}}</div>
				<div class="overview-values fw-700">{{loggedData?.componentFileShare ? loggedData?.componentFileShare : '--'}}</div>
			</div>
			<div class="pt-8 pb-8">
				<div>{{'INSTANCE_DETAILS.COMPONENT_FILE_PATH' | transloco}}</div>
				<div class="overview-values fw-700 status-color">{{loggedData?.componentFilePath ? loggedData?.componentFilePath :'--'}}</div>
			</div>
		</div>
		<mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
		<div class="flex flex-row">
			<div class="pt-8 pb-8">
				<div>{{'INSTANCE_DETAILS.ENDPOINT' | transloco}}
					<mat-icon *ngIf="loggedData?.overview?.endpoint" class="h-18 w-18 mr-6" [ngClass]="[copyEnd ? 'copiedEnd': 'copyEnd']" [svgIcon]="copyEnd ? 'check' : 'content_copy'" (click)="onCopyEndPoint(loggedData?.overview?.endpoint)"></mat-icon>
				</div>
				<div class="flex flex-row">
					<div class="overview-values fw-700">{{loggedData?.overview?.endpoint ? loggedData?.overview?.endpoint : '--'}}</div>
				</div>
			</div>
		</div>
		<mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
		<div class="flex flex-row">
			<div class="pt-8 pb-8">
				<div>{{'INSTANCE_DETAILS.USERNAME' | transloco}}
					<mat-icon *ngIf="loggedData?.overview?.username" class="h-18 w-18 mr-6" [ngClass]="[copyName ? 'copiedName': 'copyName']" [svgIcon]="copyName ? 'check' : 'content_copy'" (click)="onCopyUserName(loggedData?.overview?.username)"></mat-icon>
				</div>
				<div class="flex flex-row">
					<div class="overview-values fw-700 status-color">{{loggedData?.overview?.username ? loggedData?.overview?.username : '--'}}</div>
				</div>
			</div>
		</div>
		<mat-divider class="mb-20 mt-20 neutral-2 mat-divider-dashed"></mat-divider>
		<div class="flex flex-row">
			<div class="metrics pt-8 pb-8">
				<div>{{'INSTANCE_DETAILS.ENCRYPTION' | transloco}}</div>
				<div class="overview-values fw-700">{{loggedData?.encEnabled}}</div>
			</div>
		</div>
	</div>
</ng-container>